import { CommonModule, UpperCasePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ContattaciForm } from '../../models/forms/contattaci.form';
import { EmailService } from '../../services/email.service';
import { TitleService } from '../../services/title.service';

@Component({
    selector: 'app-contattaci',
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './contattaci.component.html',
    styleUrl: './contattaci.component.css'
})
export class ContattaciComponent {
  f!: FormGroup;
  mailText: string = "";

  // sedi disponibili per la listbox
  sedi = [
    {
      id: 'trigoria',
      label: 'Trigoria',
      email: 'info.trigoria@fullmuscle.eu'
    },
    {
      id: 'fonte-laurentina',
      label: 'Fonte Laurentina',
      email: 'info.laurentina@fullmuscle.eu'
    }
  ];

  constructor(
    private ts: TitleService,
    public router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private mailService: EmailService
  ) {
    this.f = this.formBuilder.group({
      nome: [{ value: '', disabled: false }],
      cognome: [{ value: '', disabled: false }],
      telefono: [{ value: '', disabled: false }],
      mail: [{ value: '', disabled: false }],
      note: [{ value: '', disabled: false }],
      tipoRichiesta: [{ value: '', disabled: false }],
      sede: [{ value: '', disabled: false }]   // ⬅ nuovo controllo
    });
  }

  ngOnInit() {
    this.ts.titolo = 'Contattaci';
  }

  get sede() {
    return this.f.get('sede')?.value;
  }

  onSubmit(req: any /* o ContattaciForm aggiornato */): void {
    if (this.f.valid) {

      // trova la sede selezionata
      const sedeSelezionata = this.sedi.find(s => s.id === req.sede);

      // se non selezionata, fallback ad una mail di default
      const mailDestinatario = sedeSelezionata
        ? sedeSelezionata.email
        : 'gestione@fullmuscle.eu';

      const subject = 'Richiesta informazioni';
      const body =
        'Sono ' +
        (req.nome || '') +
        ' ' +
        (req.cognome || '') +
        '.\n' +
        (req.note || '');

      this.mailText =
        'mailto:' +
        mailDestinatario +
        '?subject=' +
        encodeURIComponent(subject) +
        '&body=' +
        encodeURIComponent(body);

      window.location.href = this.mailText;
    } else {
      console.log('form non valido');
    }
  }
}